import { createRouter as _createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/Home.vue'),
    meta: { 
      title: '首页',
      showLayout: true
     },
  },
  // 注册页
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register.vue'), // 创建新的注册组件
    meta: { 
      title: '注册账号',
      showLayout: false
    }
  },
  {
    // 子页面共用一层壳（PageView 里只有一个 <router-view>）。
    // 注意：这里不再给壳单独注册一个名为 'PageView' 的 '/' 路由 ——
    // 那样会与上面 Home 的 '/' 重复注册，是同 path 的冗余定义。
    // 壳本身没有独立地址，只作为 children 的容器存在。
    path: '/',
    component: () => import('@/views/PageView.vue'),
    children: [
      {
        path: 'products',
        name: 'Products',
        component: () => import('@/views/products/Products.vue'),
        meta: {
          title: '产品',
          showLayout: true
        }
      },
      {
        path: 'pricing',
        name: 'Pricing',
        component: () => import('@/views/pricing/Pricing.vue'),
        meta: {
          title: '价格',
          showLayout: true
        }
      },
      { 
        path: 'solutions',
        name: 'Solutions',
        component: () => import('@/views/solutions/Solutions.vue'),
        meta: {
          title: '解决方案',
          showLayout: true
        }
      },
      { 
        path: 'about',
        name: 'About',
        component: () => import('@/views/about/About.vue'),
        meta: {
          title: '关于我们',
          showLayout: true
        }
      },
      {
        path: '/news/:id',
        name: 'NewsDetail',
        component: () => import('@/views/about/NewsDetail.vue') // 新闻详情页面
      }
    ]
  },
];

export function createRouter(){
  return _createRouter({
      history: createWebHistory('/'),
      routes,
      // 添加滚动行为配置
      scrollBehavior(to, from, savedPosition) {
        // 如果有保存的位置（浏览器前进/后退），则使用保存的位置
        if (savedPosition) {
          return savedPosition
        }
        // 否则滚动到页面顶部
        return { top: 0 }
      }
    })
}